// src/features/account/pages/accountHelpers.js
import i18n from "../../../i18n";

export const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

export const parseDate = (v) => {
  const s = safeStr(v).trim();
  if (!s) return null;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

export const formatActivityTime = (date, locale = "en") => {
  const d = date instanceof Date ? date : parseDate(date);
  if (!d) return "";

  const now = new Date();
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();

  const dayLabel = i18n.t("today");

  const timeStr =
    locale === "ru"
      ? d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })
      : d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });

  if (sameDay) return `${dayLabel} ${timeStr}`;

  const dateStr =
    locale === "ru"
      ? d.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" })
      : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

  return `${dateStr} ${timeStr}`;
};

export const actionIcon = (action) => {
  const a = safeStr(action).toLowerCase();
  if (a === "login") return <i class="lni lni-enter"></i>;
  if (a === "edit") return <i class="lni lni-pencil-1"></i>;
  if (a === "delete") return <i class="lni lni-trash-3"></i>;
  if (a === "email") return <i class="lni lni-envelope-1"></i>;
  if (a === "call") return <i class="lni lni-telephone-1"></i>;
  if (a === "message") return <i class="lni lni-comment-1-text"></i>;
  if (a === "meeting") return <i class="lni lni-google-meet"></i>;
  if (a === "create") return <i class="lni lni-plus"></i>;
  return "•";
};

// эвристика “как в рефе”, пока нет реального status из API
export const activityTags = (action) => {
  const a = safeStr(action).toLowerCase();
  if (a === "login") {
    return [{ label: "account_activity_accepted", tone: "accepted" }];
  }
  if (a === "create") {
    return [
      { label: "account_activity_new", tone: "new" },
      { label: "account_activity_in_progress", tone: "progress" },
    ];
  }
  if (a === "edit") {
    return [{ label: "account_activity_in_progress", tone: "progress" }];
  }
  return [];
};
